import {
  AfterViewChecked,
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'app-exg-tab-v2',
  templateUrl: './exg-tab-v2.component.html',
  styles: []
})
export class ExgTabV2Component implements OnInit, AfterViewInit, AfterViewChecked {

  _selectedtab = 0;

  @Input() header!: Array<ExgTabV2ComponentHeaderElement>;

  @Input() set selectedtab(value: number) {
    // externes setzen des tabs, interner Setter bei onTabClick
    const e: ElementRef | any = this.tabs.toArray()[value];
    this.onTabClick(value, e.nativeElement);
  }

  get selectedtab(): number {
    return this._selectedtab;
  }

  @ContentChild('pages') pages: TemplateRef<ElementRef> | null = null;

  @Output() tabchange: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('container') container!: ElementRef;
  @ViewChild('headercontainer') headercontainer!: ElementRef;
  @ViewChild('headercontainerwrapper') headercontainerwrapper!: ElementRef;
  @ViewChildren('xyz', {read: Element}) tabs!: QueryList<Element>;

  scroll = 0;
  maxScroll = 0;
  hasOverflow = false;

  get showLeftChevron(): boolean {
    return this.hasOverflow && this.scroll < 0;
  }

  get showRightChevron(): boolean {
    return this.hasOverflow && this.scroll > this.maxScroll;
  }

  get style(): string {
    return `transform: translate(${this.scroll}px,0);`;
  }

  private contentscroll = 0;

  get contentstyle(): string {
    return `transform: translate(${this.contentscroll}px,0)`;
  }


  constructor() {
  }

  ngOnInit(): void {

  }

  private getViewportWidth(): number {
    return (this.headercontainerwrapper.nativeElement as Element).getBoundingClientRect().width;
  }

  scrollTabs(direction: number): void {
    const tabWidth = this.tabs.length > 0 ? (this.tabs.first as HTMLElement).offsetWidth : 150;
    this.scroll -= direction * tabWidth;

    if (this.scroll < this.maxScroll) {
      this.scroll = this.maxScroll;
    }
    if (this.scroll > 0){
      this.scroll = 0;
    }
  }

  onTabClick(i: number, element: Element): void {
    /* Change selected Tab and toggle hidden attribute */
    if (i !== this._selectedtab) {
      if (this.container.nativeElement.querySelector('.tab-content').children.length > i) {
        this.container.nativeElement.querySelector('.tab-content').children[i].removeAttribute('hidden');
      }
      if (this.container.nativeElement.querySelector('.tab-content').children.length > this._selectedtab) {
        this.container.nativeElement.querySelector('.tab-content').children[this._selectedtab].setAttribute('hidden', true);
      }
    }
    const viewport = (this.container.nativeElement as Element).getBoundingClientRect();
    const wrapperWidth = this.getViewportWidth();
    const tabcontainer = (this.headercontainer.nativeElement as Element).scrollWidth;
    const elementLeft = element.getBoundingClientRect().left - viewport.x;
    const elementRight = element.getBoundingClientRect().right - viewport.x;
    const htmlelement = (element as HTMLElement);

    this.hasOverflow = tabcontainer > wrapperWidth;
    this.maxScroll = tabcontainer * -1 + wrapperWidth;


    if (elementRight > viewport.width - 48) {
      this.scroll = htmlelement.offsetLeft * -1;
    }
    if (elementLeft < 48) {
      this.scroll = htmlelement.offsetLeft * -1 + viewport.width - htmlelement.offsetWidth - 16;
    }

    if (this.scroll < this.maxScroll) {
      this.scroll = this.maxScroll;
    }
    if (this.scroll > 0) {
      this.scroll = 0;
    }

    // nur feuern wenn nicht extern gesetzt wird
    this._selectedtab = i;
    this.tabchange.emit(this._selectedtab);

    /* Check if hidden attibute takes effect and correct visible tab multiplier for contentscroll */
    let multiplier = this.selectedtab;
    for (let index = 0; index < this.container.nativeElement.querySelector('.tab-content').children.length; index++) {
      if (this.container.nativeElement.querySelector('.tab-content').children[index].clientWidth === 0) {
        multiplier--;
      }
    }
    if (multiplier < 0) {
      multiplier = 0;
    }
    this.contentscroll = multiplier * viewport.width * -1;

  }

  onWheel(e: WheelEvent): void {

    e.preventDefault();
    const wrapperWidth = this.getViewportWidth();
    const elementWidth = (this.headercontainer.nativeElement as Element).scrollWidth;

    this.hasOverflow = elementWidth > wrapperWidth;
    this.maxScroll = elementWidth * -1 + wrapperWidth;

    this.scroll = this.scroll + e.deltaY;

    if (this.scroll < this.maxScroll) {
      this.scroll = this.maxScroll;
    }
    if (this.scroll > 0) {
      this.scroll = 0;
    }

  }

  ngAfterViewInit(): void {
    /* Initialize and set hidden attribute to all not selectedTabs */
    for (let i = 0; i < this.container.nativeElement.querySelector('.tab-content').children.length; i++) {
      if (i === this._selectedtab) {
        this.container.nativeElement.querySelector('.tab-content').children[i].removeAttribute('hidden');
      } else {
        this.container.nativeElement.querySelector('.tab-content').children[i].setAttribute('hidden', true);
      }
    }
  }

  ngAfterViewChecked(): void {
    if (this.container && this.headercontainer && this.headercontainerwrapper) {
      const wrapperWidth = this.getViewportWidth();
      const elementWidth = (this.headercontainer.nativeElement as Element).scrollWidth;
      const overflow = elementWidth > wrapperWidth;
      const max = elementWidth * -1 + wrapperWidth;

      if (this.maxScroll !== max || this.hasOverflow !== overflow) {
        setTimeout(() => {
          this.maxScroll = max;
          this.hasOverflow = overflow;
        });
      }
    }
  }

}

export type ExgTabV2ComponentHeaderElement = {
  caption: string;
  icon_class: string;
  disabled?: boolean;
  hidden?: boolean;
  data?: any | undefined;
};
